import {
  GET_LINKED_ACCOUNTS_PENDING,
  GET_USER_PAYMENT_FAILED,
  GET_SINGLE_USER_PAYMENT_FAILED,
  GET_USER_PAYMENT_PENDING,
  GET_SINGLE_USER_PAYMENT_PENDING,
  GET_USER_PAYMENT_FULFILLED,
  GET_SINGLE_USER_PAYMENT_FULFILLED,
  GET_USER_ACCOUNT_BALANCE_PENDING,
  GET_USER_ACCOUNT_BALANCE_FAILED,
  GET_USER_ACCOUNT_BALANCE_FULFILLED,
} from "constants-lib/actionTypes"

const initialState = {
  getPaymentDetailsStatus: ``,
  totalCurrent: ``,
  totalCurrentWithCredits: ``,
  invoice: {},
  billingDetails: {},
  currency: ``,
  amountBalanceByAccount: {},
  userAccountBalance: {},
  getUserAccountBalanceStatus: ``,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_LINKED_ACCOUNTS_PENDING:
      return initialState

    case GET_USER_PAYMENT_FAILED:
    case GET_SINGLE_USER_PAYMENT_FAILED:
      return {
        ...state,
        getPaymentDetailsStatus: `failed`,
      }

    case GET_USER_PAYMENT_PENDING:
    case GET_SINGLE_USER_PAYMENT_PENDING:
      return {
        ...state,
        getPaymentDetailsStatus: `pending`,
      }

    case GET_USER_PAYMENT_FULFILLED:
    case GET_SINGLE_USER_PAYMENT_FULFILLED:
      return {
        ...state,
        getPaymentDetailsStatus: `fulfilled`,
        ...action.payload,
      }

    case GET_USER_ACCOUNT_BALANCE_PENDING:
      return {
        ...state,
        getUserAccountBalanceStatus: `pending`,
        userAccountBalance: {},
      }

    case GET_USER_ACCOUNT_BALANCE_FAILED:
      return {
        ...state,
        getUserAccountBalanceStatus: `failed`,
        userAccountBalance: {},
      }

    case GET_USER_ACCOUNT_BALANCE_FULFILLED:
      return {
        ...state,
        getUserAccountBalanceStatus: `fulfilled`,
        amountBalanceByAccount: action.payload.amountBalanceByAccount,
      }

    default:
      return state
  }
}
